import { SELECTED_MENU_ITEMS } from 'src/store/_models/dynamic-modal-layer/dynamicModalLayer.constants';

export const sourcesDesktopNew = [
  SELECTED_MENU_ITEMS.GooglePhoto,
  SELECTED_MENU_ITEMS.Smartphone,
  SELECTED_MENU_ITEMS.FamilyFriends,
];
export const sourcesDesktopTopNew = [
  SELECTED_MENU_ITEMS.Computer,
  SELECTED_MENU_ITEMS.GooglePhoto,
  SELECTED_MENU_ITEMS.Smartphone,
  SELECTED_MENU_ITEMS.FamilyFriends,
];
export const sourcesMobileNew = [
  SELECTED_MENU_ITEMS.Gallery,
  SELECTED_MENU_ITEMS.GooglePhoto,
  SELECTED_MENU_ITEMS.FamilyFriends,
];
export const sourcesMobileBottomNew = [SELECTED_MENU_ITEMS.GooglePhoto, SELECTED_MENU_ITEMS.FamilyFriends];
export const sourcesMobileBottomOld = [SELECTED_MENU_ITEMS.GooglePhoto];
export const sourcesDesktopOld = [SELECTED_MENU_ITEMS.GooglePhoto];
export const sourcesDesktopTopOld = [SELECTED_MENU_ITEMS.Computer, SELECTED_MENU_ITEMS.GooglePhoto];
export const sourcesMobileOld = [SELECTED_MENU_ITEMS.Gallery, SELECTED_MENU_ITEMS.GooglePhoto];

export const SourcesEventType = {
  Computer: 'native',
  Gallery: 'native',
  GooglePhoto: 'gphoto',
  Smartphone: 'smartphone',
  FamilyFriends: 'famiglia_e_amici',
};

export const SelectedMenuItem2SourcesEventTypeMap: { [key in SELECTED_MENU_ITEMS]: string } = {
  [SELECTED_MENU_ITEMS.Computer]: SourcesEventType.Computer,
  [SELECTED_MENU_ITEMS.Gallery]: SourcesEventType.Gallery,
  [SELECTED_MENU_ITEMS.GooglePhoto]: SourcesEventType.GooglePhoto,
  [SELECTED_MENU_ITEMS.Smartphone]: SourcesEventType.Smartphone,
  [SELECTED_MENU_ITEMS.FamilyFriends]: SourcesEventType.FamilyFriends,
  [SELECTED_MENU_ITEMS.Add]: SourcesEventType.Computer,
};
